(function(){'use strict';
/* ==========================================================
   AM SETTING - CUSTOMER COUNT (edit monthly)
   This is the ONLY number to change. It appears as
   "Trusted by X+ customers" above the review wall.
   ========================================================== */
var AM_CUSTOMER_COUNT=6743;
/* ========================================================== */
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}ready(function(){var menu=document.getElementById('ArtimaesMenu');if(menu){var body=document.body;var openMenu=function(){menu.classList.add('is-open');menu.setAttribute('aria-hidden','false');body.style.overflow='hidden';};var closeMenu=function(){menu.classList.remove('is-open');menu.setAttribute('aria-hidden','true');body.style.overflow='';};document.addEventListener('click',function(e){var trigger=e.target.closest('[data-js-popup-button="navigation"], [data-artimaes-menu-toggle]');if(trigger){e.preventDefault();e.stopPropagation();if(menu.classList.contains('is-open')){closeMenu();}else{openMenu();}}var closer=e.target.closest('[data-artimaes-menu-close]');if(closer){e.preventDefault();closeMenu();}},true);document.addEventListener('keydown',function(e){if(e.key==='Escape'&&menu.classList.contains('is-open')){closeMenu();}});menu.addEventListener('toggle',function(e){var target=e.target;if(target.tagName!=='DETAILS'||!target.open)return;var parentList=target.parentElement.parentElement;if(!parentList||!parentList.classList.contains('artimaes-menu__list'))return;Array.prototype.forEach.call(parentList.children,function(li){var details=li.querySelector(':scope > details');if(details&&details!==target&&details.open){details.open=false;}});},true);}
document.addEventListener('click',function(e){var a=e.target.closest('a[href="#am-reviews"]');if(!a)return;var t=document.getElementById('am-reviews')||document.querySelector('[id*="carousel_reviews"]')||document.querySelector('carousel-reviews');if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}});
/* Strip review dates at render time (data untouched) */
document.querySelectorAll('.carousel-reviews__paragraph').forEach(function(p){
  p.innerHTML=p.innerHTML.replace(/\s+on\s+[A-Za-z]{3,9}\.?\s+\d{1,2}(?:st|nd|rd|th)?,?\s+\d{4}/g,'');
});
var rTitle=document.querySelector('carousel-reviews .home-section-title');
if(rTitle&&!document.querySelector('.am-reviews-subtitle')){
  var sub=document.createElement('p');
  sub.className='am-reviews-subtitle';
  sub.innerHTML='Trusted by <span class="am-counter">0</span>+ customers';
  rTitle.insertAdjacentElement('afterend',sub);
  var span=sub.querySelector('.am-counter');
  var played=false;
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting&&!played){
          played=true;
          var target=AM_CUSTOMER_COUNT;
          var startTs=null;var dur=1400;
          var step=function(ts){
            if(!startTs)startTs=ts;
            var pr=Math.min((ts-startTs)/dur,1);
            var eased=1-Math.pow(1-pr,3);
            span.textContent=Math.round(eased*target).toLocaleString('en-US');
            if(pr<1)requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
          io.disconnect();
        }
      });
    },{threshold:0.4});
    io.observe(sub);
  }else{
    span.textContent=AM_CUSTOMER_COUNT.toLocaleString('en-US');
  }
}
/* ==========================================================
   AM: Live predictive search in the menu drawer
   Uses Shopify's native /search/suggest.json endpoint
   ========================================================== */
var sInput=document.querySelector('.artimaes-menu__search-input');
if(sInput){
  var sWrap=document.querySelector('.artimaes-menu__search');
  var sRes=document.createElement('div');
  sRes.className='artimaes-menu__search-results';
  sWrap.insertAdjacentElement('afterend',sRes);
  var sTimer=null;
  var goSearch=function(){var q=sInput.value.trim();if(q){window.location.href='/search?q='+encodeURIComponent(q)+'&type=product';}};
  var fmtPrice=function(p){var n=Number(p);if(isNaN(n))return p;return 'Rs.'+n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});};
  var sized=function(u){if(!u)return u;return u+(u.indexOf('?')>-1?'&':'?')+'width=120';};
  sInput.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();goSearch();}});
  sInput.addEventListener('input',function(){
    clearTimeout(sTimer);
    var q=sInput.value.trim();
    if(q.length<2){sRes.innerHTML='';return;}
    sTimer=setTimeout(function(){
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag')
        .then(function(r){return r.json();})
        .then(function(d){
          if(sInput.value.trim()!==q)return;
          var prods=(d&&d.resources&&d.resources.results&&d.resources.results.products)||[];
          if(!prods.length){
            sRes.innerHTML='<p class="artimaes-menu__search-empty">Nothing found — try “loafer”, “black”, or a name like “Warren”.</p>';
            return;
          }
          var h='';
          prods.forEach(function(p){
            var img=(p.featured_image&&p.featured_image.url)?p.featured_image.url:(p.image||'');
            h+='<a class="artimaes-menu__search-item" href="'+p.url+'">'+(img?'<img src="'+sized(img)+'" alt="" loading="lazy">':'')+'<span class="artimaes-menu__search-item-info"><span class="artimaes-menu__search-item-title">'+p.title+'</span>'+(p.price?'<span class="artimaes-menu__search-item-price">'+fmtPrice(p.price)+'</span>':'')+'</span></a>';
          });
          h+='<button type="button" class="artimaes-menu__search-all" data-am-search-all>View all results →</button>';
          sRes.innerHTML=h;
          var allBtn=sRes.querySelector('[data-am-search-all]');
          if(allBtn){allBtn.addEventListener('click',goSearch);}
        })
        .catch(function(){});
    },250);
  });
}
});})();